import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import styles from './styles.module.scss';
import { useParams } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import CaseDossier from 'components/CaseDossier';
import SearchBar from 'components/SearchBar';

const SharesModule = () => {
  const { t } = useTranslation();
  const { filterId } = useParams();

  const [searchText, setSearchText] = useState('');

  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.left}>
            <div className={styles.title}>{t("navigation.shares")}</div>
          </div>
          <div className={styles.right}>
            <SearchBar
              onChange={(t) =>
                handleChangeSearchBar(t)
              }
            />
          </div>
        </div>
        <div className={styles.main}>
          <CaseDossier
            Case={null}
            shares={true}
            filterId={filterId}
            searchText={debouncedText}
            previewInModal={true}
          ></CaseDossier>
        </div>
      </div>
    </>
  );
};
export default SharesModule;
